export default __webpack_public_path__ + "c52ba1c5b65f2ed14a9ad13eefdacf6a.svg";